export default __webpack_public_path__ + "static/castleShare-39e0d0e76b9bd231a601c7bf8985ee24.png";